// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3C0gA","overflowing":"ReadFullNote_overflowing__3TRtm"};